module.exports = __webpack_public_path__ + "img/shuidao.e017fa00.jpg";